import * as React from 'react';

/*
 I took the idea for this pattern from: https://github.com/gaearon/react-document-title
 Basically, this is a composable component that allows you to use the redux architecture to set app state based on
 component hierarchy.
 */

interface DynamicUpdateComponentProps extends React.Props<any> {
  dispatchFn(any): any;
  value: any;
}

class DynamicUpdateComponent extends React.Component<DynamicUpdateComponentProps, any> {
  componentDidMount() {
    const { dispatchFn, value } = this.props;
    dispatchFn(value);
  }

  UNSAFE_componentWillReceiveProps() {
    const { dispatchFn, value } = this.props;
    dispatchFn(value);
  }

  render() {
    const { children } = this.props;
    if (children) {
      return React.Children.only(children);
    } else {
      return null;
    }
  }
}

export default DynamicUpdateComponent;
